<div class="container-fluid row col-12 no-gutters">
  <div class="col-xl-9 col-md-8 col-sm-12 no-gutters">
    <div class="col-xl-9 col-md-9 col-sm-12 col-12 m-auto no-gutters">
      <h6 class="col-12 mb-3 text-normal"><strong>Application
          Description</strong>
      </h6>
      <div class="col-12 text-normal mb-3">Oracle Transportation Management and the GE Logistics Execution Center
        provides assistance with logistics and Freight management. OTM is the web-based solution
        that provides planning, execution, measurement and evaluation for Global Logistics &
        Transportation for shipments over 150lbs
      </div>
      <h6 class="col-12 text-normal"><strong>Registration
          Question</strong>
      </h6>
      <div class="row col-12 mt-3 no-gutters text-normal">
        <p>
          Please follow this <a href="https://registration.gepower.com/catalog" class="text-highlight">
            LINK
          </a>
           to register this application
        </p>
      </div>
    </div>
  </div>
  <div class="col-12 col-sm-12 col-md-4 col-xl-3 no-gutters">
    <div class="row no-gutters col-12 align-items-center justify-content-center d-none d-sm-block">
      <button class="btn btn-primary btn-vernova button col-12" style="font-size: 18px;" (click)="goToApplication()">
        <span>
          Go To Application
          <i class='fa fa-sign-out pl-2' style="color: #fff;"></i>
        </span>
      </button>
    </div>
    <hr>
    <div class="col-12">
      <h6>
        <strong class="mt-3 text-lable">
          Support
        </strong>
      </h6>
      <div class="col-12 mt-3 p-0 text-normal d-block d-sm-none">
        <button class="btn btn-primary btn-vernova button col-12" style="font-size: 18px;" (click)="goToApplication()">
          <span>
            Go To Application
            <i class='fa fa-sign-out pl-2' style="color: #fff;"></i>
          </span>
        </button>
        <hr>
      </div>

      <div class="col-12 mt-3 text-normal p-0">
        <h6><strong class="mt-3">NAM Region:</strong></h6>
      </div>
      <div class="col-12 mt-2 text-normal p-0">Domestic (<a href="mailto:USrenewables.domestic@ge.com" style="word-wrap: break-word;" class="text-highlight">USrenewables.domestic@ge.com</a>)</div>
      <div class="col-12 mt-2 text-normal p-0">International (<a href="mailto:NAMRenewables.imports@ge.com" style="word-wrap: break-word;" class="text-highlight">NAMRenewables.imports@ge.com</a>)</div>
      <div class="col-12 mt-2 text-normal p-0">International Export (<a href="mailto:NAMRenewables.exports@ge.com" style="word-wrap: break-word;" class="text-highlight">NAMRenewables.exports@ge.com</a>)</div>
      <div class="col-12 mt-2 text-normal p-0">Cross-border Shipments (<a href="mailto:nam.crossborder@ge.com" style="word-wrap: break-word;" class="text-highlight">nam.crossborder@ge.com</a>)</div>

      <div class="col-12 mt-3 text-normal p-0">
        <h6><strong class="mt-3">EMEA Region:</strong></h6>
      </div>
      <div class="col-12 mt-2 text-normal p-0">Renewables (<a href="mailto:renewables.otmeurope@ge.com" style="word-wrap: break-word;" class="text-highlight">renewables.otmeurope@ge.com</a>)</div>

      <div class="col-12 mt-3 text-normal p-0">
        <h6><strong class="mt-3">APAC Region:</strong></h6>
      </div>
      <div class="col-12 mt-2 text-normal p-0">Renewables (<a href="mailto:renewables.otmasia@ge.com" style="word-wrap: break-word;" class="text-highlight">renewables.otmasia@ge.com</a>)</div>

      <div class="col-12 mt-3 text-normal p-0">
        <h6><strong class="mt-3">IND Region:</strong></h6>
      </div>
      <div class="col-12 mt-2 text-normal p-0">Domestic (<a href="mailto:IND-Domestic@ge.com" style="word-wrap: break-word;" class="text-highlight">IND-Domestic@ge.com</a>)</div>
      <div class="col-12 mt-2 text-normal p-0">Imports (<a href="mailto:Renew-Imports@ge.com" style="word-wrap: break-word;" class="text-highlight">Renew-Imports@ge.com</a>)</div>
      <div class="col-12 mt-2 text-normal p-0">Exports (<a href="mailto:Renew-Exports@ge.com" style="word-wrap: break-word;" class="text-highlight">Renew-Exports@ge.com</a>)</div>

      <div class="col-12 mt-3 text-normal p-0">
        <h6><strong class="mt-3">IND Region (LM Wind):</strong></h6>
      </div>
      <div class="col-12 mt-2 text-normal p-0">Imports (<a href="mailto:lmexportindia@ge.com" style="word-wrap: break-word;" class="text-highlight">lmexportindia@ge.com</a>)</div>
      <div class="col-12 mt-2 text-normal p-0">Exports (<a href="mailto:lmimportindia@ge.com" style="word-wrap: break-word;" class="text-highlight">lmimportindia@ge.com</a>)</div>

      <!-- GERITM49524650 -->
      <!-- <div class="col-12 mt-3 text-normal p-0">
        <h6><strong class="mt-3">General Application Support:</strong></h6>
      </div>
      <div class="col-12 mt-2 text-normal p-0">Brad Summers (<a href="mailto:bradley.summers@ge.com" style="word-wrap: break-word;" class="text-highlight">bradley.summers@ge.com</a>)</div>
      <div class="col-12 mt-2 text-normal p-0">Tracey Moore (<a href="mailto:tracey.moore@ge.com" style="word-wrap: break-word;" class="text-highlight">tracey.moore@ge.com</a>)</div> -->

    </div>
    <hr>
  </div>
</div>